import React, { useEffect, useState } from 'react';
import { useDrop } from 'react-dnd';
import classNames from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';

import { AnswerOptionStatus } from '../../../../../api/private/learn-engine-api/learn-engine-api.interface';

import { getQuestionItemClassName } from '../utils';
import { DnDAnswerOption } from '../interface';
import { DND_ACCEPT_TYPES } from '../constants';

import s from './DnDQuestionV2.scss';

export interface IDnDQuestionItemV2Props {
    index: number;
    onSelect: (id: number) => void;
    value: DnDAnswerOption;
    status?: AnswerOptionStatus;
    isCurrent?: boolean;
    isCode?: boolean;
}

export function DnDQuestionItemV2({
    value,
    index,
    status,
    onSelect,
    isCurrent,
    isCode,
}: IDnDQuestionItemV2Props): JSX.Element {
    useStyles(s);
    const [options, setOptions] = useState<Record<string, unknown>>(null);
    const [{ isOver, item }]: any = useDrop({
        accept: [DND_ACCEPT_TYPES.DRAG_OPTION],
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
            item: monitor.getItem(),
        }),
    });

    useEffect(() => {
        if (item && isOver && !value) {
            setOptions(item.options);
        }
    }, [item, isOver, value]);

    useEffect(() => {
        if (options && !value) {
            setOptions(null);
        }
    }, [options, value]);

    return (
        <div
            className="sl-dnd-question-v2__item-container"
            sl-test-data="cmpDnDQuestionItemContainer"
        >
            <div
                className={classNames(
                    'sl-dnd-question-v2__item',
                    status || getQuestionItemClassName(),
                    {
                        current: isCurrent,
                        code: isCode,
                    }
                )}
                style={{
                    ...value?.options,
                    opacity: isOver ? '0' : '1',
                }}
                tabIndex={0}
                onClick={() => onSelect(index)}
            >
                {value?.text || ''}
            </div>
            <div
                className={classNames('layer sl-dnd-question-v2__item', {
                    active: isOver,
                })}
                style={{
                    opacity: isOver ? '1' : '0',
                }}
            />
        </div>
    );
}
